import { observable, set, computed } from 'mobx';

export interface ICounter {
    id: number;
    name: string;
    serviceIds: number[];
}

export class Counter implements ICounter {
    @observable public id: number;
    @observable public name: string;
    @observable public serviceIds: number[];
    @observable public storeNumber: string;

    constructor(data: ICounter) {
        set(this, data);
    }

    @computed
    public get hasServicesAvailable() {
        return this.serviceIds && this.serviceIds.length > 0;
    }
}
